// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iweb-mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--iweb-z-index-mask);
  display: block;
  width: 100%;
  height: 100%;
}
.iweb-mask-hidden {
  display: none;
}
.iweb-mask-enter {
  opacity: 0;
}
.iweb-mask-enter-active {
  opacity: 1;
  transition: opacity 200ms ease-out;
}
.iweb-mask-exit {
  display: block;
  opacity: 1;
}
.iweb-mask-exit-active {
  opacity: 0;
  transition: opacity 200ms ease-in;
}
`, "",{"version":3,"sources":["webpack://./../../node_modules/@ali/infinite-webui/es/web-components/Mask/mask.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,iCAAiC;EACjC,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,kCAAkC;AACpC;AACA;EACE,cAAc;EACd,UAAU;AACZ;AACA;EACE,UAAU;EACV,iCAAiC;AACnC","sourcesContent":[".iweb-mask {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--iweb-z-index-mask);\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n.iweb-mask-hidden {\n  display: none;\n}\n.iweb-mask-enter {\n  opacity: 0;\n}\n.iweb-mask-enter-active {\n  opacity: 1;\n  transition: opacity 200ms ease-out;\n}\n.iweb-mask-exit {\n  display: block;\n  opacity: 1;\n}\n.iweb-mask-exit-active {\n  opacity: 0;\n  transition: opacity 200ms ease-in;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
